const bagItems = [
  { id: 'bag_01', title: 'Chanel & Prada', image: '/static/images/ai_bag/bag_01.jpg' },
  { id: 'bag_02', title: 'Louis Vuitton', image: '/static/images/ai_bag/bag_02.jpg' },
  { id: 'bag_03', title: 'Louis Vuitton', image: '/static/images/ai_bag/bag_03.jpg' },
  { id: 'bag_04', title: 'Gucci Bamboo', image: '/static/images/ai_bag/bag_04.jpg' },
  { id: 'bag_05', title: 'Dior Boston', image: '/static/images/ai_bag/bag_05.jpg' },
  { id: 'bag_06', title: 'Dior Saddle', image: '/static/images/ai_bag/bag_06.jpg' },
  { id: 'bag_07', title: 'Prada Leather', image: '/static/images/ai_bag/bag_07.jpg' },
  { id: 'bag_08', title: 'Hermes Kelly', image: '/static/images/ai_bag/bag_08.jpg' },
  { id: 'bag_12', title: 'Celine Croco', image: '/static/images/ai_bag/bag_12.jpg' },
  { id: 'bag_19', title: 'Fendi Wynn', image: '/static/images/ai_bag/bag_19.jpg' },
  { id: 'bag_20', title: 'Saint Laurent', image: '/static/images/ai_bag/bag_20.jpg' },
]

export default {
  all: bagItems
}



// WEBPACK FOOTER //
// ./src/constants/aiBagCatalog.js